<template>
  <div>
    <div class="uk-grid uk-flex-row uk-flex-top uk-grid-collapse" uk-grid>
      <div class="uk-width-3-4">
        <div class="uk-flex uk-flex-wrap uk-grid-small">
          <TenantCombobox :label="$t('fields.tenant')" v-model="filter.tenant" />
          <div>
            <form-group class="combobox" :label="$t('labels.filtersInRevisions')">
              <multiselect class="filters-in-revision-combobox" v-model="filtersInRevision"
                :options="revisionFiltersOptions" :multiple="true" :close-on-select="false" :clear-on-select="false"
                :preserve-search="true" placeholder="Pick some" label="name" track-by="name">
              </multiselect>
            </form-group>
          </div>
          <div class="uk-width-1-4">
            <label>{{ this.$t('labels.alwaysDisplayed') }}</label>
            <select ref="primaryInput" class="uk-select" v-model="filter.hasAlwaysDisplayed" @click="onInput">
              <option :value="null"></option>
              <option :value="false">No</option>
              <option :value="true">Yes</option>
            </select>
          </div>
          <ProviderComboBox v-model="filter.provider" />
        </div>
      </div>

      <div class="uk-width-1-4">
        <checkbox class="product-filter-checkbox" :label="$t('labels.revisionCheckbox')"
          v-model="filter.hasRevisions" />
        <checkbox class="product-filter-checkbox" :label="$t('labels.bundleCheckbox')" v-model="filter.bundle" />
        <checkbox class="product-filter-checkbox" :label="$t('labels.filterStockSkipUpdateCheckbox')"
          v-model="filter.hasStockSkipUpdate" />
      </div>
    </div>
    <div class="uk-margin-top" uk-grid>
      <button class="uk-button uk-button-default" @click="handleFilterClick">Filtern</button>
    </div>
  </div>
</template>

<script>
import Icon from '@/components/Icon';
import TextInput from '@/components/TextInput';
import Combobox from '@/components/Combobox';
import Checkbox from '@/components/Checkbox';
import TenantCombobox from '@/components/TenantCombobox';
import ProviderComboBox from '@/components/ProviderComboBox';
import SelectInput from '@/components/SelectInput';
import Multiselect from 'vue-multiselect';
import FormGroup from '@/components/FormGroup';


/**
 * Contains different filter for the product view.
 * Emits a filter event when the button is clicked.
 */
export default {
  name: 'products-filter',
  components: {
    Checkbox,
    Combobox,
    Icon,
    ProviderComboBox,
    TenantCombobox,
    TextInput,
    SelectInput,
    Multiselect,
    FormGroup,
  },
  props: {
    buttonName: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      revisionFiltersOptions: [{ name: 'Ignored safe amount', value: true }],
      filtersInRevision: [],
      visibleOptions: [
        true,
        false,
      ],
      filter: {
      },
    };
  },
  i18n: {
    messages: {
      de: {
        labels: {
          revisionCheckbox: 'Revisionen?',
          alwaysDisplayed: 'Always Displayed?',
          bundleCheckbox: 'Bundle?',
          filtersInRevisions: 'Filters in Revisions',
          filterStockSkipUpdateCheckbox: 'PXSDB Bestand-Import deaktiviert?',
        },
      },
    },
  },
  watch: {
    filtersInRevision(selectedFilters) {
      if (selectedFilters.length === 0) {
        delete this.filter.hasPxsdbSecureBufferDisabled;
        return;
      }
      selectedFilters.forEach((filter) => {
        if (filter.name === 'Ignored safe amount') {
          this.filter.hasPxsdbSecureBufferDisabled = filter.value;
        } else {
          delete this.filter.hasPxsdbSecureBufferDisabled;
        }
      });
    },
  },
  methods: {
    onInput() {
      if (this.filter.hasAlwaysDisplayed == null) {
        delete this.filter.hasAlwaysDisplayed;
      }
    },
    handleFilterClick() {
      const filterCopy = { ...this.filter };
      if (filterCopy.tenant) {
        filterCopy.tenantId = filterCopy.tenant.id;
      }
      delete filterCopy.tenant;
      this.$emit('filter', filterCopy);
    },
  },
};
</script>

<style lang="scss">
.tenant-combobox {
  width: 15rem;
}

.provider-combobox {
  width: 20rem;
}

.filters-in-revision-combobox {
  width: 25rem;
}

.product-filter-checkbox {
  margin-top: 2rem !important;
}
</style>



// WEBPACK FOOTER //
// ProductsFilter.vue?017443e4